class BrandImageOverlay {
    constructor(parent) {
      if (!parent) {
        return;
      }
  
      this.parent = parent;
      this.Slider();
    }
  
    Slider = () => {
      let parent = this.parent;
      let BrandOverlaySlider = qsa(
        ".brand-image-section .brand-text-slider-js"
      );
      BrandOverlaySlider.length > 0 &&
      BrandOverlaySlider.forEach((el) => {
          this.swiper(el);
        });
    };
  
    swiper = (element) => {
      let loop = element.getAttribute("data-loop") == "true" ? true : false;
      let autoplay = element.getAttribute("data-auto-rotate") == "true" ? true : false;
      let time = parseInt(element.getAttribute("data-slide-time")) * 1000;
      let slides = parseInt(element.getAttribute("data-slide-per-view"));

      let options = {
        loop,
        slidesPerView: 2.5,
        spaceBetween: 20,
        breakpoints: {
          990:{
            slidesPerView: slides,
            spaceBetween: 20
          },
          767: {
            slidesPerView: slides-1,
            spaceBetween: 20
          }
        }
      };

  
      if (autoplay) {
        options["autoplay"] = {
          delay: time,
        };
      }
  
      let swiper = new Swiper(element, options);
    };
  }
  
  
  new BrandImageOverlay(qs(".brand-image-section"));
  